export default __webpack_public_path__ + "static/media/problem-finding-img2.c176b122.png";